import type { IItem } from 'types';

export const convertItemArrayToObject = (items: IItem[]): Record<string, IItem> => {
  return items.reduce((result, item) => {
    result[item.id] = item;
    return result;
  }, {} as Record<string, IItem>);
};

export const getPreviewUrlFromSourceUrl = (sourceUrl: string | URL | HTMLCanvasElement, maxSize = 300): string => {
  if (sourceUrl instanceof HTMLCanvasElement) {
    return '';
  }

  let url: string;
  if (sourceUrl instanceof URL) {
    url = sourceUrl.toString();
  } else {
    url = sourceUrl;
  }

  return !url.trim?.() ? '' : url.startsWith('blob:') ? url : `${url}?to=max&r=${maxSize}`;
};
